import { useCookieConsent } from "./cookie";
import { useGoogleAds } from "./google";

function ThirdParty() {
  useCookieConsent();

  useGoogleAds();

  return null;
}

export { ThirdParty };
